import BookData from "./book_data";
import { settingStore } from "./store/settingStore";
import AppRender from "../js/app_renderer";
import EventBus from "./event_bus";
import { focusStore } from "./store/nowFocusStore";
import { afileStore } from "./store/afileStore";
import { bookPageStore } from "./store/bookPageStore";
import SystemData from "./system_data";

export default class AFileControl {
    afiles = [];
    loadingAfile = null;
    static instance;


    constructor() {
    }

    /**
     * 
     * @returns {AFileControl}
     */
    static getInstance() {
        if (this.instance == null) {
            this.instance = new AFileControl();
        }

        return AFileControl.instance;
    }

    /**
     * 開啟一個普通A檔
     * @param {string} fileName A檔檔案名稱
     * @param {number} frame 指定目標影格
     * @param {*} startFrame 初始影格
     * @memberof AFileControl
     */
    open(fileName, frame, startFrame) {
        const afile = {
            "type": "afile",
            "id": new Date().getTime(),
            "fileName": fileName,
            "frame": frame || 0,
            "startFrame": isNaN(startFrame) ? frame : startFrame
        };

        console.log("open afile: startFrame: ", afile.startFrame, " targetFrame: ", afile.frame);
        this.addAfile(afile);
        this.loadingAfile = afile;
    }

    openMovie(fileName) {
        if (settingStore.useCustomPlayer) {
            if (SystemData.Instance.getPlatform() == 'darwin'){
                let path = BookData.Instance.getBookPath() + fileName;
                let newPath = SystemData.Instance.changePathToMac(path);
                AppRender.Instance.openFile(newPath);
            }else{
                AppRender.Instance.openFile(BookData.Instance.getBookPath() + fileName);
            }
        } else {
            const afile = {
                "type": "afileMovie",
                "id": new Date().getTime(),
                "fileName": fileName,
                "frame": 0
            };
            this.addAfile(afile);
            this.loadingAfile = afile;
        }
    }

    openChangeImage(fileName, total) {
        const afile = {
            "type": "afileImage",
            "id": new Date().getTime(),
            "fileName": fileName,
            "frame": 0,
            "total": total
        };
        this.addAfile(afile);
        this.loadingAfile = afile;
    }

    addAfile(afile) {
        let currentAfile = this.afiles.find(value => value.fileName == afile.fileName && value.frame == afile.frame);
        if (currentAfile) {
            this.afiles.sort(a => (a.fileName == afile.fileName && a.frame == afile.frame) ? -1 : 1);

            focusStore.setNowPageItemControl(currentAfile.itemControl, afile.type);
            EventBus.getInstance().getAppRefs()[`afile_${afile.fileName}_${afile.frame}`][0].$refs.aFileWindow.$refs.aFileTool.handleWindow();
            EventBus.getInstance().getAppRefs()[`afile_${afile.fileName}_${afile.frame}`][0].$refs.aFileWindow.setFocusPainter();
        } else {
            if (this.afiles.length >= 4) return;
            this.afiles.unshift(afile);
        }
    }

    removeAfile(afile) {
        console.log(this.afiles);
        let index = this.afiles.indexOf(afile);
        console.log("remove afile:", afile, "\nindex: ", index);

        document.getElementById(`afile${index}`).querySelectorAll("canvas").forEach(canvas => {
            canvas.width = 0;
            canvas.height = 0;
        })

        this.afiles.splice(index, 1);

        if(this.afiles.length == 0) {
        	afileStore.maximum = false;
            bookPageStore.isHidden = false;
        }
    }

    clearAfiles() {
        this.afiles.splice(0);
    }

    topAfile(afile) {
        let currentAfile = this.afiles.find(value => value.fileName == afile.fileName && value.frame == afile.frame);
        if (currentAfile) {
            this.afiles.sort(a => (a.fileName == afile.fileName && a.frame == afile.frame) ? -1 : 1);

            focusStore.setNowPageItemControl(currentAfile.itemControl, afile.type);
            // EventBus.getInstance().getAppRefs()[`afile_${afile.fileName}_${afile.frame}`][0].$refs.aFileWindow.$refs.aFileTool.handleWindow();
            EventBus.getInstance().getAppRefs()[`afile_${afile.fileName}_${afile.frame}`][0].$refs.aFileWindow.setFocusPainter();
        }
    }
}